module.exports = __webpack_public_path__ + "static/media/l200-2015-mn.db195779.png";